import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { AppState } from 'app/types';
import { Loggable } from 'app/utils/logging/loggable';
import SocialTheme from 'entity/SocialTheme';
import SocialThemeData from 'entity/SocialThemeData';
import SocialThemeInfo from 'entity/SocialThemeInfo';
import SocialThemeType from 'enums/SocialThemeType';
import BackgroundController from 'rest/BackgroundController';
import Paging from 'rest/Paging';

@Injectable({
  providedIn: 'root',
})
export class BackgroundService extends Loggable {
  private backgroundController = new BackgroundController();

  public constructor(private store: Store<AppState>) {
    super();
    this.setDisplayName('BackgroundService');
  }

  public createCustomTheme(themeData: SocialThemeData): Promise<SocialTheme> {
    return this.backgroundController.createCustomTheme(themeData);
  }

  /*
   Get my themes
   */
  public getMyThemes(page?: Paging): Promise<SocialTheme[]> {
    // TODO: pass room size
    return this.backgroundController.getMyThemes(20000, 20000, page);
  }

  /*
 Get theme infos
 */

  public getThemesInfos(roomSize: number, page?: Paging): Promise<SocialThemeInfo> {
    return this.backgroundController.getThemeInfos(roomSize, roomSize, page);
  }

  /*
 Get system themes
 */

  public getThemes(type: SocialThemeType, page?: Paging): Promise<SocialTheme[]> {
    // TODO: pass room size
    return this.backgroundController.getThemes(type, 20000, 20000, page);
  }

  /*
     Get Social Theme by SocialThemeId
  */

  public getSocialTheme(socialThemeId: string): Promise<SocialTheme> {
    return this.backgroundController.getSocialTheme(socialThemeId);
  }

  /*
    Delete social theme
  */

  public deleteCustomTheme(socialThemeId: string): Promise<void> {
    return this.backgroundController.deleteCustomTheme(socialThemeId);
  }

  /*
    update social theme
  */

  public updateSocialTheme(themeData: SocialThemeData): Promise<SocialTheme> {
    return this.backgroundController.updateCustomTheme(themeData);
  }
}
